module.exports = __webpack_public_path__ + "img/marker-delivered.6b0614a9.svg";